import React, { FC, useState } from 'react'
import { FormModal, IFormModalProps } from 'transfix-ui/components/Modals'
import { Spinner } from 'transfix-ui/components/Spinner'
import { useGlobalToast } from 'transfix-ui/components/Toast/GlobalToast'
import { Box } from 'transfix-ui/core'
import { useDeleteStaplesHeadhaulLane } from 'apps/marketplace/apiTypes/staplesHeadhaulLanes'

interface IDeleteConfirmationModalProps extends Pick<IFormModalProps, 'open' | 'onClose'> {
  laneId: number
  onRefetch: () => void
}

export const DeleteConfirmationModal: FC<IDeleteConfirmationModalProps> = ({
  laneId,
  onClose,
  onRefetch,
  open,
}) => {
  const { openToast } = useGlobalToast()
  const [errorMessage, setErrorMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const { mutate: destroyStaplesHeadhaulLane } = useDeleteStaplesHeadhaulLane({})

  const deleteStaplesHeadhaulLane = async () => {
    setIsLoading(true)
    try {
      await destroyStaplesHeadhaulLane(laneId)
      onRefetch()
      openToast({
        toastMessage: 'Staples headhaul lane succesfully deleted',
        toastType: 'default',
      })
      onClose()
    } catch {
      setErrorMessage('An unknown error occurred.')
      setIsLoading(false)
    }
  }

  return (
    <FormModal
      size={4}
      onClose={onClose}
      open={open}
      error={errorMessage}
      title='Are you sure?'
      className='ph0'
      actions={[
        {
          type: 'dismiss',
          label: 'Cancel',
          dataTest: 'cancel-button',
          action: onClose,
          disabled: isLoading,
        },
        {
          label: 'Delete',
          type: 'confirm',
          dataTest: 'delete-confirm-button',
          action: deleteStaplesHeadhaulLane,
          disabled: isLoading,
        },
      ]}>
      <span>We will delete this lane.</span>
      {isLoading && (
        <Box>
          <Spinner position='relative' />
        </Box>
      )}
    </FormModal>
  )
}
